export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  // Dashboard
  'menu.admin.dashboard': 'Dashboard',
  // User Management
  'menu.admin.user-list': 'User List',
  'menu.admin.kyc': 'KYC Management',
  'menu.admin.user-detail': 'User Detail',
  'menu.admin.user-keys': 'API Key Management',
  // VCC Management
  'menu.admin.vcc-products': 'Products',
  'menu.admin.vcc-applications': 'Applications',
  'menu.admin.vcc-cards': 'Cards',
  // Wallet Management
  'menu.admin.wallet-records': 'Transaction Records',
  'menu.admin.wallet-history': 'History',
  'menu.admin.withdraw-config': 'Withdraw Config',
  // Swap Management
  'menu.admin.swap-manage': 'Swap Config',
  'menu.admin.swap-orders': 'Swap Orders',
  // Distribution Management
  'menu.admin.commission': 'Commission',
  // System Management
  'menu.admin.roles': 'Roles',
  'menu.admin.operation-logs': 'Operation Logs',
  // Legacy menu (for compatibility)
  'menu.admin.user-manage': 'User Management',
  'menu.admin.role-manage': 'Roles & Permissions',
  'menu.admin.kyc-manage': 'KYC Management',
  'menu.admin.card-manage': 'Card Management',
  'menu.admin.card-application': 'Card Applications',
  'menu.admin.user-cards': 'User Cards',
  'menu.admin.commission-manage': 'Commission Management',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.wallet': 'Wallet',
  'menu.wallet.records': 'Transaction Records',
  'menu.wallet.history': 'History',
  'menu.account': 'Account',
  'menu.account.center': 'Referral Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.card-center': 'Card Center',
  'menu.account.assets': 'My Assets',
  'menu.account.my-cards': 'Card Application',
  'menu.account.user-cards': 'My Cards',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  // Global Management
  'menu.global': 'Global Management',
  'menu.global.finance': 'Finance Overview',
  'menu.global.users': 'User Management',
  'menu.global.deposits': 'Deposit Management',
  'menu.global.custody-products': 'Custody Products',
  'menu.global.custody-orders': 'Custody Orders',
  'menu.global.withdrawals': 'Withdrawals',
  'menu.global.commission-config': 'Commission Config',
  'menu.global.commission-records': 'Commission Records',
  'menu.global.commission-vesting': 'Commission Vesting',
  'menu.global.team-performance': 'Team Performance',
};
